// Génère un mot de passe fort, sans caractères ambigus (0/O, 1/l/I),
// adapté à une communication écrite/orale au staff.
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789@#%+=?';

export function generatePassword(length = 14): string {
  const out: string[] = [];
  const buf = new Uint32Array(length);
  crypto.getRandomValues(buf);
  for (let i = 0; i < length; i++) {
    out.push(ALPHABET[buf[i] % ALPHABET.length]);
  }
  return out.join('');
}
